module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/star-53d6705b9c5023edcd203a998b3e98b4.svg";